import { useMutation, useQueryClient } from 'react-query';
import { useAPI } from '@axo/shared/data-access/provider';
import { ace_api } from '@axo/shared/data-access/api';
import { aceAssignmentKeys } from '../../cache-keys/aceAssignmentKeys';

export function useSetAgentUnavailableV3() {
  const api = useAPI();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ace_api.setAgentUnavailableV3(api),
    onSettled: (_, __, { AgentID }) => {
      queryClient.invalidateQueries([aceAssignmentKeys.agent(AgentID)]);
    },
  });
}
